import React from "react";
import { classes } from "@bloomberg/media-ui-core";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./snapshotOverview.module.css";
import { QuoteData, SeriesKeys } from "~types/types";
import {
  DATA_FIELDS_BY_SECURITY_TYPE,
  DATA_FIELD_NAME_TRANSFORM,
} from "~utils/snapshotOverviewUtils";
import SnapshotDetail from "~components/SnapshotDetail";
import { useTranslateMessage, TranslatedMessage } from "~utils/i18n";
import type { TransformEntry } from "~types/i18n";

type QuoteTableData = Omit<QuoteData, SeriesKeys>;

export type SnapshotOverviewProps = {
  quoteData: QuoteTableData;
};

export default function SnapshotOverview(props: SnapshotOverviewProps) {
  const { quoteData } = props;
  const translateMessage = useTranslateMessage();

  const nonNullFields = DATA_FIELDS_BY_SECURITY_TYPE[quoteData.type]?.filter(
    (field) => quoteData[field] !== null
  );

  if (!nonNullFields || !nonNullFields?.length) {
    return null;
  }

  return (
    <div className={styles.snapshotOverview}>
      <div className={classes([styles.title, typographyStyles.coreHeadlineXs])}>
        <TranslatedMessage id={"overview"} defaultMessage={"Overview"} />
      </div>
      <div className={styles.snapshotOverviewDetails}>
        {nonNullFields?.map((field) => {
          const fieldDetail = quoteData[field];
          const { id, defaultMessage } = DATA_FIELD_NAME_TRANSFORM[
            field
          ] as TransformEntry;
          const fieldLabel = translateMessage({
            id,
            defaultMessage,
          });

          if (fieldDetail) {
            return (
              <SnapshotDetail
                key={field}
                field={fieldLabel}
                fieldDetail={fieldDetail}
                isRealTime={quoteData.isRealTime}
              />
            );
          }

          return null;
        })}
      </div>
    </div>
  );
}
